<template>
	<div id="app">
		<transition name="my">
			<router-view class="child-view slide"></router-view>
		</transition>
	</div>
</template>

<script>
import Vue from 'vue';
import { skinConfig } from './utils/config';

export default {
	name: 'app',
	mounted() {
		Vue.$Sensors.init();

    if(skinConfig) {
      sessionStorage.setItem('isNewSkin', '1');
    } else {
      let isNewSkin = sessionStorage.getItem('isNewSkin');
      if(isNewSkin) {
        sessionStorage.removeItem('isNewSkin');
      } 
    }
	},
};
</script>

<style lang="scss">
* {
	box-sizing: border-box;
}
html,
body {
	height: 100%;
	width: 100%;
}
#app {
	// 控制页面内容不可以选择
	user-select: none;
	height: 100%;
	width: 100%;
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	position: relative;
}
.m {
	&_b5 {
		margin-bottom: 5px;
	}
	&_b10 {
		margin-bottom: 10px;
	}
	&_b15 {
		margin-bottom: 15px;
	}
	&_b35 {
		margin-bottom: 35px;
	}
}
.c {
	&_w {
		color: white;
	}
}
.t {
	&_ac {
		text-align: center;
	}
	&_ar {
		text-align: right;
	}
}
.f {
	&_12 {
		font-size: 12px;
	}
	&_14 {
		font-size: 14px;
	}
	&_15 {
		font-size: 15px;
	}
	&_18 {
		font-size: 18px;
	}
	&_25 {
		font-size: 25px;
	}
	&w {
		font-weight: bold;
	}
}
.lh22 {
	line-height: 22px;
}
.p {
	&_r10 {
		padding-right: 10px;
	}
	&_r20 {
		padding-right: 20px;
	}
}

// 动画：
.my-enter {
	opacity: 0;
	transform: translateX(100%);
}
.my-leave-to {
	opacity: 0;
	transform: translateX(-100%);
	position: absolute;
}
.my-enter-active,
.my-leave-active {
	transition: all 0.5s ease;
}

.child-view {
	width: 100%;
	height: 100%;
	overflow-x: hidden;
	overflow-y: scroll;
	position: absolute;
	top: 0;
	left: 0;
	// background-image: url("./assets/image/bgc01.png");
	background-size: 100% 100%;
	transition: all 0.3s ease-in-out;
	&::-webkit-scrollbar {
		width: 0;
	}

	&.slide-left-enter,
	&.slide-right-leave-active {
		opacity: 0;
		&.slide {
			transform: translate(100%, 0);
		}
	}

	&.slide-left-leave-active,
	&.slide-right-enter {
		opacity: 0;
		&.slide {
			transform: translate(-100%, 0);
		}
	}
}
</style>
